<template>
  <v-app> <router-view /> </v-app>
</template>

<style>
.FontSize {
  font-size: 12px !important;
}
.FontSize13px {
  font-size: 13px;
}
.FontSize20px {
  font-size: 20px !important;
}
.v-input .v-label {
  font-size: 12px;
}
.MaxWidth {
  max-width: 200px;
}
.MaxWidthVariant1 {
  max-width: 150px !important;
}
.MaxWidthVariant2 {
  max-width: 350px !important;
}
.DialogTrasition {
  align-self: flex-start !important;
}
.FontSize10px {
  font-size: 12px !important;
  font-weight: bold !important;
}
.gradient-back {
  background: -webkit-linear-gradient(
    180deg,
    #e8efeb 20%,
    #86e6ac 70%
  ) !important;
  background: -moz-linear-gradient(180deg, #e8efeb 20%, #86e6ac 70%) !important;
  background: -o-linear-gradient(180deg, #e8efeb 20%, #86e6ac 100%) !important;
  background: -ms-linear-gradient(180deg, #e8efeb 20%, #86e6ac 100%) !important;
  background: linear-gradient(180deg, #e8efeb 20%, #86e6ac 70%) !important;
}
.OTPUsersSet {
  font-size: 14px !important;
  color: grey !important;
  font-weight: 600;
}
.cardBorder {
  border-radius: 10px !important;
}
.CursorPointer {
  cursor: pointer !important;
}

.gradient-bg {
  background: -webkit-linear-gradient(
    145deg,
    #0fc566 0%,
    #0a876e 100%
  ) !important;
  background: -moz-linear-gradient(145deg, #0fc566 0%, #0a876e 100%) !important;
  background: -o-linear-gradient(145deg, #0fc566 0%, #0a876e 100%) !important;
  background: -ms-linear-gradient(145deg, #0fc566 0%, #0a876e 100%) !important;
  background: linear-gradient(145deg, #0fc566 0%, #0a876e 100%) !important;
}
.TableClass th {
  font-size: 12px !important;
}
.TableClass td {
  font-size: 12px !important;
}
/* .SelectFontSize .v-list-item {
  font-size: 12px !important;
} */
.SelectFontSize .v-list-item-title {
  font-size: 14px !important;
  font-weight: 500 !important;
}
.SelectFontSize .v-list-item {
  min-height: 40px !important;
}
</style>
